import { useMutation } from '@tanstack/react-query'
import { downloadToolkit } from './services'

export const useDownloadToolkit = () => {
  return useMutation(downloadToolkit)
}
